import axiosInstance from "./AxiosInstance";

export const updateCallStatus = (payload) => {
  return axiosInstance.post("lead/updateCallStatus", payload);
};

export const markCallReceived = (payload) => {
    return axiosInstance.post("lead/markCallReceived", payload);
  };